<template>
	<div id="app">
		<router-view v-wechat-title='$route.meta.title'></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
	}
</script>

<style>
/* @font-face{
	font-family: PingFangR;
	src: url("/static/fonts/PingFangR.ttf");
	
} */
@font-face{
	font-family: PingFangB;
	src: url("/static/fonts/PingFangB.ttf");
	
}
@font-face{
	font-family: PingFangM;
	src: url("/static/fonts/PingFangM.ttf");
	
}
	#app {
		width: 10rem;
		min-height: 100vh;
		font-family: PingFangM,'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* padding: 0 0.25rem; */
		box-sizing: border-box;
		/* background-color: rgb(245,245,245); */
		border:0.01rem solid transparent;
	}
	.topTitle {
		width: 100%;
		height: 1.06rem;
		background: white;
		color: #1C1C1C;
		font-weight: bold;
		font-size: 0.5rem;
		text-align: center;
		line-height: 1.06rem;
		border-bottom: 0.02rem solid rgb(245,245,245);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 11;
		/* margin-bottom: 0.8rem; */
	}
	.backImg{
		position: absolute;
		top: 0.18rem;
		left: 0.2rem;
		width: 0.64rem;
		height: 0.64rem;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue